<template>
<!--  选择关联报销单-->
<div style="box-sizing: border-box; height: calc(100vh - 190px);">
  <div class="search">
    <form action="/">
      <van-search
          v-model="keywords"
          :clearable="false"
          background="#0093FF"
          placeholder="请输入搜索关键词"
          @search="onSearch"
      >
        <template #right-icon>
          <van-icon v-if="keywords" name="clear" color="#adb5bd" size="20" @click="clear"/>
        </template>
      </van-search>
    </form>
  </div>
  <div class="content" ref="targetElement" style="height: calc(100vh - 50px); overflow: auto; padding-bottom: 50px; padding-top: 60px; position: relative; margin-top: 10px">
    <div>
      <van-pull-refresh v-model="loading" success-text="刷新成功" @refresh="onRefresh">
        <van-list v-model="loading"
                  :finished="finished"
                  finished-text="没有更多了"
                  :error.sync="error"
                  error-text="请求失败，点击重新加载"
                  @load="refreshList">
          <van-radio-group v-model="result">
            <div class="content-item" v-for="(item, index) in dataList" :key="index">
              <div style="margin-left: 8px; width: 20px; display: flex; align-items: center">
                <van-radio ref="checkbox" :name="item"></van-radio>
              </div>
              <div class="row-item">
                <div class="item-name">{{item.code}}</div>
                <div class="item-sellName">名称：{{item.name}}</div>
                <div class="item-amount">请款金额：{{item.request_amount.toFixed(2)}}</div>
                <div class="item-amount">申请日期：{{item.date}}</div>
              </div>

            </div>
          </van-radio-group>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
  <van-popup v-model="show" round position="bottom" :style="{ height: '30%' }">
	<van-list>
	  <van-cell v-for="user in result.users" :key="user.id" :title="user.name" @click="confirm(user.id)"/>
	</van-list>
  </van-popup>
  <div class="confirm" @click="chooseUser">确定</div>
</div>
</template>

<script>
import InvoiceService from '@/api/invoice/InvoiceService.js' ;
export default {
  name: "expenseSelect",
  data(){
    return {
      dataList: [],
      loading: false,
      finished: false,
      error: false,
      current: 1,
      size: 10,
      total: 0,
      result: {},
      keywords: '',
      invoiceIds: [],
	  show: false
    }
  },
  created() {
    // console.log(this.$route.query)

  },
  activated(){
    // this.onRefresh()
  },
  mounted() {
    this.invoiceIds = this.$route.query.invoiceIds
  },
  methods: {
    onSearch(){
      this.onRefresh()
    },
    clear(){
      this.keywords = ''
      this.onRefresh()
    },
    onRefresh() {
      this.current = 1
      this.size = 10
      this.dataList = []
      this.result = {}
      this.refreshList()
    },
    refreshList() {
      // Vue.cookie.set('token', "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ0eXBlIjoiZGluZyIsImV4cCI6MTczMDU1MDY2OSwidXNlcm5hbWUiOiJ3YW5nbWluIn0.8BFrdFyLtyr9b-4J4gDWScpcv-_l_KOBL0z8Qs43OkQ");
      this.loading = true;
      new InvoiceService().expenseList({
        current: this.current,
        pageSize: this.size,
        keywords: this.keywords
      }).then(({data}) => {
        this.dataList.push(...data.records)
        this.total = data.total
        this.loading = false
        this.error= false
        this.finished = this.total / this.size <= this.current
        if (!this.finished) {
          this.current += 1
        }
      }).catch(()=>{
        this.loading = false;
        this.error = true
        // this.finished = true;
      })
    },
	chooseUser(){
		if(this.result.id) {
			if(this.result.users.length == 1){
				this.confirm(this.result.users[0].id)
			}else{
				this.show = true;
			}
		} else {
			this.$toast.fail('请选择报销单')
		}
	},
    confirm(userId){
		this.$dialog.confirm({message: '确定关联选中报销单？'}).then(()=>{
		  new InvoiceService().confirmExpense({
			invoiceIds: this.invoiceIds,
			businessId: this.result.id,
			businessType: '5',
			reimburser: userId
		  }).then((res)=>{
			this.$toast.success(res.data.msg)
        // this.onRefresh()
        this.$router.back()
		  }).catch(()=>{
		    this.$toast.fail('关联报销单失败')
      })
		})
    }
  }
}
</script>

<style scoped>
.search {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
}

.content {
  width: 100%;
  height: calc(100vh - 50px);
  /*margin-top: 100px;*/
  /*margin-bottom: 65px;*/
  position: relative;
}

.content-item {
  width: 100%;
  /*height: 60px;*/
  background-color: #fff;
  display: flex;
  border-bottom: 1px solid #ececec;
}

.confirm {
  width: 100%;
  padding-left: 20px;
  padding-right: 20px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  /*display: flex;*/
  /*align-items: center;*/
  /*justify-content: space-between;*/
  background-color: #1989fa;
  color: #FFFFFF;
  position: fixed;
  bottom: 0;
  left: 0;
  font-size: 18px;
  border-top: 1px solid #ececec;
}
.row-item{
  width: 85%;
  padding: 5px 5px 8px 15px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.item-name{
  width: 280px;
  font-size: 15px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #e29700;
}
.item-sellName{
  width: 280px;
  font-size: 11px;
  color: #000000;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.item-amount{
  font-size: 11px;
  display:block;
  color: #4D4D4D;
}
</style>